export interface Inbox {
  id: string;
  name: string;
  description: string;
  channels: InboxChannel[];
  addressDomain: string;
}

export interface InboxChannel {
  id: string;
  name: string;
  type: InboxChannelType;
  address?: string;
  description: string;
  isActive: boolean;
  dedicatedWorkflowAgentTypes: WorkflowAgentType[];
  incomingDomainWhitelist?: string[];
}

export type WorkflowAgentType = string;

export const allInboxChannelTypes = ["Email", "Api"] as const;

export type InboxChannelType = (typeof allInboxChannelTypes)[number];

export interface SearchInboxesRequest {
  channelType?: InboxChannelType;
  channelAddress?: string;
}

export interface CreateInboxRequest {
  name: string;
  description: string;
}

export interface UpdateInboxRequest {
  name?: string;
  description?: string;
  channels?: UpdateInboxChannelRequest[];
}

export interface UpdateInboxChannelRequest {
  isNewChannel: boolean;
  id?: string;
  name: string;
  type: InboxChannelType;
  address?: string;
  description: string;
  isActive: boolean;
  dedicatedWorkflowAgentTypes: WorkflowAgentType[];
  incomingDomainWhitelist?: string[];
}

export interface AgentInfo {
  agentId: string;
  agentName: string;
  agentDescription: string;
  workflowAgentType: WorkflowAgentType;
}

export interface InboxItem {
  id: string;
  inboxId: string;
  receivedAt: string;
  channelType: InboxChannelType;
  from: string;
  fromAddress?: string;
  fromUserName?: string;
  to: string;
  toAddress?: string;
  toUserName?: string;
  subject?: string;
  numberOfAttachments: number;
}
